import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FormikValidator = () => {
  const { values, validateForm } = useFormikContext();

  useEffect(() => {
    validateForm();
  }, [values, validateForm]);

  return null;
};

export default FormikValidator;
